module.exports = __webpack_public_path__ + "media/property/image_placeholder-5a4eff62.jpg";